import { Storybook } from "@tento-ui/ui/storybook";
import { TurnAsk } from "./ask";

export class TurnAskStoryBook extends Storybook.Default {
  title(): string {
    return "Turn · ask";
  }

  examples(): Storybook.Example[] {
    return [
      {
        title: "Pending command",
        render: () =>
          TurnAsk.makeWith({
            title: "Terminal",
            command:
              "/bin/zsh -lc \"git -C tsh status --short\nrg -n 'agent_context' tsh/tsh/src\"",
            options: [
              {
                optionId: "allow_always",
                name: "Always Allow",
                kind: "allow_always",
              },
              { optionId: "allow", name: "Allow", kind: "allow_once" },
              { optionId: "reject", name: "Reject", kind: "reject_once" },
            ],
            state: "pending",
          }),
      },
      {
        title: "Pending edit, no command block",
        render: () =>
          TurnAsk.makeWith({
            title: "Edit index.root.ts",
            options: [
              { optionId: "allow", name: "Allow", kind: "allow_once" },
              { optionId: "reject", name: "Reject", kind: "reject_once" },
            ],
            state: "pending",
          }),
      },
      {
        title: "Decided",
        render: () =>
          TurnAsk.makeWith({
            title: "Terminal",
            command: "cargo build -p tento-spool",
            options: [
              { optionId: "allow", name: "Allow", kind: "allow_once" },
              { optionId: "reject", name: "Reject", kind: "reject_once" },
            ],
            state: "decided",
          }),
      },
    ];
  }
}
